import { render, staticRenderFns } from "./Missie.vue?vue&type=template&id=54d8fb12&scoped=true&"
import script from "./Missie.vue?vue&type=script&lang=ts&"
export * from "./Missie.vue?vue&type=script&lang=ts&"
import style0 from "./Missie.vue?vue&type=style&index=0&id=54d8fb12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8fb12",
  null
  
)

export default component.exports